import { Component,OnInit, ViewChild,Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ExcelService } from 'src/app/services/excel-service.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EmployeeDataTableService } from 'src/app/views/employee-data-table/employee-data-table.service';
import { Router } from '@angular/router';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';

@Component({
  selector: 'app-access-employee-dashboard',
  templateUrl: './access-employee-dashboard.component.html',
  styleUrls: ['./access-employee-dashboard.component.css'],

})
export class AccessEmployeeDashboardComponent implements OnInit{
  displayedColumns = [
    "employeeId",
    "firstName",
    "lastName",
    "emailId",
    "competency",
    "subCompetency",
    "SkillSet"
  ];
  searchText: string ="";
  from: any = 0;
  size: any = 10;   
  loading: boolean = true;
  totalRecords: any = 0;
  roles: any;
  _isManager: boolean = false;
  employeeCareerUserDetails?: EmployeeModel;
  emptyData = new MatTableDataSource([{ empty: "row" }]);
  public dataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    private service: EmployeeDataTableService,
    private toaster: ToastrService,
    private excel: ExcelService,
    public dialog: MatDialog,
    public router: Router,
    private auth: AuthServiceService
  ) {}

  ngOnInit() {
    this.roles = this.auth.getRole();
    this.employeeCareerUserDetails = JSON.parse(localStorage.getItem('empCareerUserDetails'));
    this._isManager = this.employeeCareerUserDetails?.isManager;
    if (this._isManager) {
      this.roles = "Manager";
    }
    this.getEmployeeAcceessData();
  }

    
  getPaginatorData(event) {
    if (event.previousPageIndex > event.pageIndex) {
      this.from = (event.pageIndex * this.size);
      this.size = event.pageSize;
    } else {
      this.size = event.pageSize;
      this.from = (event.pageIndex * this.size);
    }
    this.getEmployeeAcceessData();
  }

  getEmployeeAcceessData():Promise<any[]> {  
    this.loading = true;
    return new Promise<any[]>((resolve,reject) => {
      this.service.getAccessEmployeeDashboard(this.searchText, this.from, this.size,this.roles).subscribe(x => {
        this.dataSource = new MatTableDataSource(x.value.value.items);
        this.dataSource.sort = this.sort;
        this.totalRecords = x.value.value.total;
        this.loading = false;
      });
    });
  }

  applyFilter(filterValue: string) {
    if (filterValue.length > 2 || filterValue.length == 0) {
      if (filterValue.includes('@')) {
        filterValue = filterValue.substring(0, filterValue.indexOf("@"));
      }
      this.searchText = filterValue;
      this.from = 0;
      this.size = 10;
      this.getEmployeeAcceessData();
    }
  }

  pageNavigate(empid) {
    this.router.navigate(['Home/Dashboard/Employee Impersonation', empid]);
  }

  clearSearchText() {
    this.searchText = '';
    this.clearSearch();
  }

  clearSearch() {
    if (this.searchText == "") {
      this.getEmployeeAcceessData();
    }
  }

  getskillset(SkillSet) {
    console.log(SkillSet);
    if(Array.isArray(SkillSet)) {
      return SkillSet.join(', ');
    }
    return '';
  }
}
